import { useCopyToClipboard } from "usehooks-ts";

/**
 * @param onSuccess Wrapper for useCopyToClipboard hook which handles error and success cases safely
 * The copyToClipboard function can throw errors, and wrapping it in an inline try catch breaks react compiler optimization.
 */

export function useSafeCopyToClipboard({
  onSuccess,
  onError,
}: {
  onSuccess: () => void;
  onError: (err: Error) => void;
}) {
  const [copiedText, copyToClipboard] = useCopyToClipboard();
  const safeCopy = async (copyValue: string) => {
    try {
      await copyToClipboard(copyValue);
      onSuccess();
    } catch (err) {
      onError(err as Error);
    }
  };

  return [copiedText, safeCopy] as const;
}
